import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { DropdownLoader } from 'components/ui/DropdownLoader'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { prefixTable } from '../constants'
import optionStyles from './Options.module.scss'

interface IProps {
  onDownload: () => void
}

const Options: React.FC<IProps> = ({ onDownload }) => {
  const { t } = useTranslation()
  const [show, setShow] = useState(false)

  return (
    <div
      className={show ? optionStyles.menuOpen : undefined}
      data-menu-open={show ? 'true' : undefined}
    >
      <DropdownButton
        show={show}
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={false} />}
        onClick={() => setShow(!show)}
        onToggle={(nextShow) => setShow(nextShow)}
      >
        <a
          className={styles['option-item']}
          onClick={() => {
            setShow(false)
            onDownload()
          }}
        >
          {t(`${prefixTable}.headers.download`)}
        </a>
      </DropdownButton>
    </div>
  )
}

export default Options
